// Google Reader-style keyboard shortcuts (spec §7.1):
// j/k next/prev, o/Enter open, v original, s save, m read, Shift+A all read, / search
import { useEffect } from 'react';

export interface ShortcutHandlers {
  next?: () => void;
  prev?: () => void;
  open?: () => void;
  openOriginal?: () => void;
  toggleSaved?: () => void;
  toggleRead?: () => void;
  markAllRead?: () => void;
  search?: () => void;
}

export function useKeyboardShortcuts(handlers: ShortcutHandlers): void {
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      const target = event.target as HTMLElement;
      if (
        target.tagName === 'INPUT' ||
        target.tagName === 'TEXTAREA' ||
        target.isContentEditable ||
        event.metaKey ||
        event.ctrlKey ||
        event.altKey
      ) {
        return;
      }

      switch (event.key) {
        case 'j':
          handlers.next?.();
          break;
        case 'k':
          handlers.prev?.();
          break;
        case 'o':
        case 'Enter':
          handlers.open?.();
          break;
        case 'v':
          handlers.openOriginal?.();
          break;
        case 's':
          handlers.toggleSaved?.();
          break;
        case 'm':
          handlers.toggleRead?.();
          break;
        case 'A':
          if (event.shiftKey) handlers.markAllRead?.();
          break;
        case '/':
          event.preventDefault();
          handlers.search?.();
          break;
        default:
          return;
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [handlers]);
}
